(function () {
  if (window.customElements.get('bundle-builder')) {
    return;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function fillTemplate(template, values) {
    return template.replace(/\[(\w+)\]/g, function (match, key) {
      return values[key] !== undefined ? values[key] : match;
    });
  }

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      var dataEl = this.querySelector('[data-builder-data]');
      if (!dataEl) {
        return;
      }

      try {
        this.data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      this.data.tiers.sort(function (a, b) { return a[0] - b[0]; });
      this.units = [];
      this.expanded = false;
      this.filters = { collection: 'all', color: 'all', fit: null };
      this.previewProductId = null;

      this.productsById = {};
      this.variantsById = {};
      this.data.products.forEach(function (p) {
        this.productsById[p.id] = p;
        p.variants.forEach(function (v) {
          v.productId = p.id;
          this.variantsById[v.id] = v;
        }, this);
      }, this);

      var availablePrices = [];
      this.data.products.forEach(function (p) {
        var prices = p.variants
          .filter(function (v) { return v.available; })
          .map(function (v) { return v.price; });

        if (prices.length) {
          availablePrices.push(Math.min.apply(null, prices));
        }
      });
      this.averageUnitPrice = availablePrices.length
        ? Math.round(availablePrices.reduce(function (a, b) { return a + b; }, 0) / availablePrices.length)
        : 0;

      this.barMessage = this.querySelector('[data-bar-message]');
      this.barLeft = this.querySelector('[data-bar-left]');
      this.barRight = this.querySelector('[data-bar-right]');
      this.slotsEl = this.querySelector('[data-slots]');
      this.barEmpty = this.querySelector('[data-bar-empty]');
      this.barPrice = this.querySelector('[data-bar-price]');
      this.totalChip = this.querySelector('[data-total-chip]');
      this.totalCompare = this.querySelector('[data-total-compare]');
      this.totalEl = this.querySelector('[data-total]');
      this.checkoutButton = this.querySelector('[data-checkout]');
      this.errorEl = this.querySelector('[data-bar-error]');
      this.overlay = this.querySelector('[data-overlay]');
      this.sheet = this.querySelector('[data-size-sheet]');
      this.sheetProductId = null;
      this.sheetVariantId = null;

      this._bindTiles();
      this._bindFilters();
      this._bindBar();
      this._bindOverlay();
      this._bindSheet();
      this._preselectFromUrl();
      this._applyFilters();
      this._render();
    }

    _bindTiles() {
      this.querySelectorAll('[data-tile]').forEach(function (tile) {
        var productId = Number(tile.dataset.productId);

        var addButton = tile.querySelector('[data-tile-add]');
        if (addButton) {
          addButton.addEventListener('click', function () {
            this._requestAdd(productId);
          }.bind(this));
        }

        var plus = tile.querySelector('[data-tile-plus]');
        if (plus) {
          plus.addEventListener('click', function () {
            this._requestAdd(productId);
          }.bind(this));
        }

        var minus = tile.querySelector('[data-tile-minus]');
        if (minus) {
          minus.addEventListener('click', function () {
            this._removeUnit(productId);
          }.bind(this));
        }

        var previewButton = tile.querySelector('[data-preview-open]');
        if (previewButton) {
          previewButton.addEventListener('click', function () {
            this._openPreview(productId);
          }.bind(this));
        }
      }, this);
    }

    _bindFilters() {
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-tile]'));
      this.gridEmpty = this.querySelector('[data-grid-empty]');

      this.querySelectorAll('[data-filter-group]').forEach(function (group) {
        var groupName = group.dataset.filterGroup;

        group.querySelectorAll('[data-filter-value]').forEach(function (pill) {
          pill.addEventListener('click', function () {
            var value = pill.dataset.filterValue;

            if (groupName === 'fit') {
              if (value === 'all' || this.filters.fit === value) {
                this.filters.fit = null;
              } else {
                this.filters.fit = value;
              }
            } else {
              this.filters[groupName] = value;
            }

            this._syncFilterPills();
            this._applyFilters();
          }.bind(this));
        }, this);
      }, this);

      this.filtersClear = this.querySelector('.bundle-builder__filters-clear');

      this.querySelectorAll('[data-filters-reset]').forEach(function (reset) {
        reset.addEventListener('click', function () {
          this.filters = { collection: 'all', color: 'all', fit: null };
          this._syncFilterPills();
          this._applyFilters();
        }.bind(this));
      }, this);
    }

    _syncFilterPills() {
      this.querySelectorAll('[data-filter-group]').forEach(function (group) {
        var groupName = group.dataset.filterGroup;

        group.querySelectorAll('[data-filter-value]').forEach(function (pill) {
          var value = pill.dataset.filterValue;
          var active;

          if (groupName === 'fit') {
            active = value === 'all' ? !this.filters.fit : this.filters.fit === value;
          } else {
            active = this.filters[groupName] === value;
          }

          pill.classList.toggle('is-active', active);
        }, this);
      }, this);
    }

    _tileMatches(tile, filters) {
      if (filters.collection !== 'all') {
        var collections = (tile.dataset.collections || '').split(',');
        if (collections.indexOf(filters.collection) === -1) {
          return false;
        }
      }

      if (filters.color !== 'all' && tile.dataset.color !== filters.color) {
        return false;
      }

      if (filters.fit) {
        var tileFit = tile.dataset.fit;

        if (filters.fit === 'unisex') {
          if (tileFit !== 'unisex') {
            return false;
          }
        } else if (tileFit !== filters.fit && tileFit !== 'unisex') {
          return false;
        }
      }

      return true;
    }

    _applyFilters() {
      var visibleCount = 0;

      this.tiles.forEach(function (tile) {
        var visible = this._tileMatches(tile, this.filters);
        tile.hidden = !visible;
        if (visible) {
          visibleCount += 1;
        }
      }, this);

      if (this.gridEmpty) {
        this.gridEmpty.hidden = visibleCount > 0;
      }

      if (this.filtersClear) {
        var anyActive = this.filters.collection !== 'all' || this.filters.color !== 'all' || !!this.filters.fit;
        this.filtersClear.hidden = !anyActive;
      }

      this._updateFilterAvailability();
    }

    _updateFilterAvailability() {
      this.querySelectorAll('[data-filter-group]').forEach(function (group) {
        var groupName = group.dataset.filterGroup;

        group.querySelectorAll('[data-filter-value]').forEach(function (pill) {
          var value = pill.dataset.filterValue;

          if (value === 'all' || pill.classList.contains('is-active')) {
            pill.disabled = false;
            return;
          }

          var candidate = {
            collection: this.filters.collection,
            color: this.filters.color,
            fit: this.filters.fit
          };
          candidate[groupName] = value;

          var hasMatch = this.tiles.some(function (tile) {
            return this._tileMatches(tile, candidate);
          }, this);

          pill.disabled = !hasMatch;
        }, this);
      }, this);
    }

    _bindBar() {
      this.checkoutButton.addEventListener('click', this._addToCart.bind(this));

      this.slotsEl.addEventListener('click', function (event) {
        var toggleButton = event.target.closest('[data-slots-toggle]');
        if (toggleButton) {
          this.expanded = !this.expanded;
          this._render();
          return;
        }

        var removeButton = event.target.closest('[data-unit-remove]');
        if (!removeButton) {
          return;
        }
        var index = Number(removeButton.dataset.unitRemove);
        this.units.splice(index, 1);
        this._render();
      }.bind(this));
    }

    _bindOverlay() {
      if (!this.overlay) {
        return;
      }

      this.overlay.addEventListener('dialog:after-hide', function () {
        this.previewProductId = null;
      }.bind(this));

      this.overlay.querySelector('[data-overlay-add]').addEventListener('click', function () {
        if (this.previewProductId == null) {
          return;
        }
        var productId = this.previewProductId;
        Promise.resolve(this._closePreview()).then(function () {
          this._requestAdd(productId);
        }.bind(this));
      }.bind(this));

      this.overlay.querySelector('[data-overlay-thumbs]').addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-overlay-thumb]');
        if (!thumb) {
          return;
        }
        this.overlay.querySelector('[data-overlay-image]').src = thumb.dataset.overlayThumb;
        this.overlay.querySelectorAll('[data-overlay-thumb]').forEach(function (other) {
          other.classList.toggle('is-active', other === thumb);
        });
      }.bind(this));
    }

    _openPreview(productId) {
      var product = this.productsById[productId];
      if (!product || !this.overlay) {
        return;
      }

      this.previewProductId = productId;
      this.overlay.querySelectorAll('[data-overlay-title]').forEach(function (el) {
        el.textContent = product.title;
      });
      this.overlay.querySelector('[data-overlay-image]').src = product.images[0] || product.thumb;
      this.overlay.querySelector('[data-overlay-image]').alt = product.title;

      var productUrl = product.handle ? Shopify.routes.root + 'products/' + product.handle : '';
      this.overlay.querySelectorAll('[data-overlay-rating]').forEach(function (el) {
        if (productUrl) {
          el.setAttribute('href', productUrl + '#reviews');
        } else {
          el.removeAttribute('href');
        }
      });

      var thumbs = this.overlay.querySelector('[data-overlay-thumbs]');
      thumbs.innerHTML = '';
      product.images.forEach(function (src, index) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'bundle-builder__overlay-thumb' + (index === 0 ? ' is-active' : '');
        button.dataset.overlayThumb = src;
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        button.appendChild(img);
        thumbs.appendChild(button);
      });

      this._drawerShow(this.overlay);
    }

    _drawerShow(drawer) {
      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
      }
    }

    _drawerHide(drawer) {
      if (drawer && typeof drawer.hide === 'function') {
        return drawer.hide();
      }
      return Promise.resolve();
    }

    _closePreview() {
      this.previewProductId = null;
      return this._drawerHide(this.overlay);
    }

    _preselectFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var spec = params.get('variants');

      if (spec) {
        this._restoreFromSpec(spec, params.get('edit'));
        return;
      }

      var handle = params.get('product');
      if (!handle) {
        return;
      }

      var product = this.data.products.find(function (p) { return p.handle === handle; });
      if (!product) {
        return;
      }

      var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      if (variant) {
        this.units.push({ variantId: variant.id, productId: product.id });
      }

      var tile = this.querySelector('[data-tile][data-product-id="' + product.id + '"]');
      if (tile) {
        setTimeout(function () {
          tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
    }

    _restoreFromSpec(spec, editKey) {
      var restored = 0;
      var dropped = 0;
      var firstProductId = null;

      spec.split(',').forEach(function (part) {
        var bits = part.split(':');
        var variantId = Number(bits[0]);
        var quantity = parseInt(bits[1], 10);

        if (!quantity || quantity < 1) {
          quantity = 1;
        }

        var variant = this.variantsById[variantId];

        if (!variant || !variant.available) {
          dropped += quantity;
          return;
        }

        for (var i = 0; i < quantity; i++) {
          this.units.push({ variantId: variantId, productId: variant.productId });
          restored++;
        }

        if (firstProductId === null) {
          firstProductId = variant.productId;
        }
      }, this);

      if (restored > 0 && editKey) {
        this._removeCartLine(editKey);
      }

      if (dropped > 0 && this.errorEl) {
        var template = this.data.strings.restoreDropped;
        if (template) {
          this.errorEl.textContent = template.split('[count]').join(String(dropped));
          this.errorEl.hidden = false;
        }
      }

      if (firstProductId !== null) {
        var tile = this.querySelector('[data-tile][data-product-id="' + firstProductId + '"]');
        if (tile) {
          setTimeout(function () {
            tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 300);
        }
      }
    }

    _removeCartLine(key) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart) {
            return;
          }
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'cart:update', cart: cart }
            })
          );
        })
        .catch(function () {});
    }

    _bindSheet() {
      if (!this.sheet) {
        return;
      }

      this.sheet.addEventListener('dialog:after-hide', function () {
        this.sheetProductId = null;
        this.sheetVariantId = null;
      }.bind(this));

      this.sheet.querySelector('[data-sheet-sizes]').addEventListener('click', function (event) {
        var pill = event.target.closest('[data-sheet-size]');
        if (!pill || pill.disabled) {
          return;
        }
        this.sheetVariantId = Number(pill.dataset.sheetSize);
        this.sheet.querySelectorAll('[data-sheet-size]').forEach(function (other) {
          other.classList.toggle('is-active', other === pill);
        });
        var variant = this.variantsById[this.sheetVariantId];
        this.sheet.querySelector('[data-sheet-price]').textContent = formatMoney(variant.price);
        var addButton = this.sheet.querySelector('[data-sheet-add]');
        addButton.disabled = false;
        addButton.textContent = this.data.strings.addToSet;
      }.bind(this));

      this.sheet.querySelector('[data-sheet-add]').addEventListener('click', function () {
        if (this.sheetVariantId == null) {
          return;
        }
        this._addUnit(this.sheetVariantId);
        this._closeSheet();
      }.bind(this));
    }

    _requestAdd(productId) {
      var product = this.productsById[productId];
      if (!product) {
        return;
      }

      if (product.variants.length === 1) {
        this._addUnit(product.variants[0].id);
        return;
      }

      this._openSizeSheet(productId);
    }

    _openSizeSheet(productId) {
      var product = this.productsById[productId];
      if (!product || !this.sheet) {
        return;
      }

      this.sheetProductId = productId;
      this.sheetVariantId = null;

      this.sheet.querySelector('[data-sheet-title]').textContent = product.title;
      this.sheet.querySelector('[data-sheet-image]').src = product.thumb || product.images[0] || '';
      this.sheet.querySelector('[data-sheet-image]').alt = product.title;

      var reference = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      this.sheet.querySelector('[data-sheet-price]').textContent = reference ? formatMoney(reference.price) : '';

      var sizes = this.sheet.querySelector('[data-sheet-sizes]');
      sizes.innerHTML = '';
      product.variants.forEach(function (v) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'complete-set__sheet-size';
        pill.dataset.sheetSize = v.id;
        pill.textContent = v.size || v.id;
        pill.disabled = !v.available;
        sizes.appendChild(pill);
      });

      var addButton = this.sheet.querySelector('[data-sheet-add]');
      addButton.disabled = true;
      addButton.textContent = this.data.strings.chooseSize;

      this._drawerShow(this.sheet);
    }

    _closeSheet() {
      this.sheetProductId = null;
      this.sheetVariantId = null;
      return this._drawerHide(this.sheet);
    }

    _addUnit(variantId) {
      var variant = this.variantsById[variantId];
      if (!variant || !variant.available) {
        return;
      }
      this.units.push({ variantId: variantId, productId: variant.productId });
      this._render();
    }

    _removeUnit(productId) {
      for (var i = this.units.length - 1; i >= 0; i--) {
        if (this.units[i].productId === productId) {
          this.units.splice(i, 1);
          this._render();
          return;
        }
      }
    }

    _pctFor(count) {
      var pct = 0;
      this.data.tiers.forEach(function (tier) {
        if (count >= tier[0]) {
          pct = tier[1];
        }
      });
      return pct;
    }

    _nextTier(count) {
      for (var i = 0; i < this.data.tiers.length; i++) {
        if (count < this.data.tiers[i][0]) {
          return this.data.tiers[i];
        }
      }
      return null;
    }

    _render() {
      var count = this.units.length;
      var addedPct = this._pctFor(count + 1);

      this.querySelectorAll('[data-tile]').forEach(function (tile) {
        var productId = Number(tile.dataset.productId);
        var product = this.productsById[productId];
        var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        var qty = this.units.filter(function (u) { return u.productId === productId; }).length;

        var priceEl = tile.querySelector('[data-tile-price]');
        var compareEl = tile.querySelector('[data-tile-compare]');
        var chipEl = tile.querySelector('[data-tile-chip]');

        if (variant) {
          if (addedPct > 0) {
            priceEl.textContent = formatMoney(Math.round(variant.price * (100 - addedPct) / 100));
            compareEl.textContent = formatMoney(variant.price);
            compareEl.hidden = false;
            chipEl.textContent = '-' + addedPct + '%';
            chipEl.hidden = false;
          } else {
            priceEl.textContent = formatMoney(variant.price);
            if (variant.compare > variant.price) {
              compareEl.textContent = formatMoney(variant.compare);
              compareEl.hidden = false;
              chipEl.textContent = '-' + Math.round((variant.compare - variant.price) * 100 / variant.compare) + '%';
              chipEl.hidden = false;
            } else {
              compareEl.hidden = true;
              chipEl.hidden = true;
            }
          }
        }

        var addButton = tile.querySelector('[data-tile-add]');
        var stepper = tile.querySelector('[data-tile-stepper]');
        addButton.hidden = qty > 0;
        stepper.hidden = qty === 0;
        tile.querySelector('[data-tile-qty]').textContent = qty;

        var unavailable = !variant || !variant.available;
        addButton.disabled = unavailable;
        tile.querySelector('[data-tile-plus]').disabled = unavailable;
      }, this);

      this._renderBar(count);
    }

    _renderBar(count) {
      var currentPct = this._pctFor(count);
      var next = this._nextTier(count);
      var strings = this.data.strings;

      var tierIndex = -1;
      this.data.tiers.forEach(function (tier, index) {
        if (count >= tier[0]) {
          tierIndex = index;
        }
      });

      var runningTotal = this.units.reduce(function (sum, unit) {
        return sum + this.variantsById[unit.variantId].price;
      }.bind(this), 0);
      var threshold = Number(this.data.freeShippingThreshold) || 0;
      var firstTier = this.data.tiers[0];
      var basis = Math.round(runningTotal * (100 - currentPct) / 100);

      if (firstTier && count < firstTier[0]) {
        var unitEstimate = count > 0 ? Math.round(runningTotal / count) : this.averageUnitPrice;
        var projected = runningTotal + (firstTier[0] - count) * unitEstimate;
        basis = Math.round(projected * (100 - firstTier[1]) / 100);
      }

      var freeShipping = threshold > 0 && basis >= threshold;

      var left = '';
      var right = '';

      if (tierIndex < 0) {
        if (next) {
          left = fillTemplate(freeShipping ? strings.progressPre : strings.progressNext, { count: next[0] - count, percent: next[1] });
        }
      } else {
        var unlockedTemplate = strings.progressUnlocked;

        if (tierIndex === 0 && freeShipping) {
          unlockedTemplate = strings.progressUnlockedFirst;
        }

        left = fillTemplate(unlockedTemplate, { percent: currentPct });

        var tierEmoji = (strings.progressUnlockedEmoji || '').split(',')[tierIndex];

        if (tierEmoji && tierEmoji.trim()) {
          left = left + ' ' + tierEmoji.trim();
        }

        right = next ? fillTemplate(strings.progressNext, { count: next[0] - count, percent: next[1] }) : strings.progressMax;
      }

      this.barLeft.textContent = left;
      this.barRight.textContent = right;
      this.barMessage.classList.toggle('bundle-builder__bar-message--single', right === '');

      this._renderSlots(count, next);

      var total = this.units.reduce(function (sum, unit) {
        return sum + this.variantsById[unit.variantId].price;
      }.bind(this), 0);
      var discounted = Math.round(total * (100 - currentPct) / 100);

      this.barEmpty.hidden = count > 0;
      this.barPrice.hidden = count === 0;

      this.totalEl.classList.toggle('bundle-builder__bar-total--discounted', currentPct > 0);

      if (count > 0) {
        this.totalEl.textContent = formatMoney(discounted);
        if (currentPct > 0) {
          this.totalChip.textContent = '-' + currentPct + '%';
          this.totalChip.hidden = false;
          this.totalCompare.textContent = formatMoney(total);
          this.totalCompare.hidden = false;
        } else {
          this.totalChip.hidden = true;
          this.totalCompare.hidden = true;
        }
      }

      this.checkoutButton.disabled = count === 0;
    }

    _renderSlots(count, next) {
      var base = this.data.tiers.length
        ? this.data.tiers[this.data.tiers.length - 1][0]
        : 7;
      var minVisible = this.data.tiers.length > 1 ? this.data.tiers[1][0] : base;
      var needsToggle = count > base;
      var collapsed = needsToggle && !this.expanded;
      var visibleUnits = collapsed ? this.units.slice(0, base - 1) : this.units;
      var reserve = needsToggle ? 1 : 0;
      var totalSlots;
      if (count < minVisible) {
        totalSlots = minVisible;
      } else if (count <= base) {
        totalSlots = base;
      } else {
        totalSlots = Math.ceil((count + reserve) / base) * base;
      }
      var neededForNext = next ? next[0] - count : 0;

      this.slotsEl.innerHTML = '';

      visibleUnits.forEach(function (unit, index) {
        var variant = this.variantsById[unit.variantId];
        var product = this.productsById[unit.productId];

        var slot = document.createElement('div');
        slot.className = 'bundle-builder__slot bundle-builder__slot--filled';

        var img = document.createElement('img');
        img.src = product.thumb;
        img.alt = product.title;
        slot.appendChild(img);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'bundle-builder__slot-remove';
        remove.dataset.unitRemove = index;
        remove.setAttribute('aria-label', product.title + ' ×');
        remove.textContent = '×';
        slot.appendChild(remove);

        var size = document.createElement('span');
        size.className = 'bundle-builder__slot-size';
        size.textContent = variant.size;
        slot.appendChild(size);

        this.slotsEl.appendChild(slot);
      }, this);

      if (!collapsed) {
        for (var i = count; i < totalSlots - reserve; i++) {
          var placeholder = document.createElement('div');
          var highlighted = i < count + neededForNext;
          placeholder.className = 'bundle-builder__slot bundle-builder__slot--empty' + (highlighted ? ' bundle-builder__slot--next' : '');
          if (highlighted) {
            placeholder.textContent = '+';
          }
          this.slotsEl.appendChild(placeholder);
        }
      }

      if (needsToggle) {
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'bundle-builder__slots-toggle';
        toggle.dataset.slotsToggle = '';
        toggle.textContent = this.expanded ? this.data.strings.showLess : this.data.strings.showAll;
        this.slotsEl.appendChild(toggle);
      } else {
        this.expanded = false;
      }
    }

    async _addToCart() {
      if (!this.units.length) {
        return;
      }

      this.errorEl.hidden = true;
      this.checkoutButton.setAttribute('aria-busy', 'true');
      this.checkoutButton.disabled = true;

      var properties = null;
      var minCount = this.data.tiers.length ? this.data.tiers[0][0] : 0;

      if (this.units.length >= minCount) {
        var group = String(this.data.group || 'set').replace(/[^a-zA-Z0-9_]/g, '');
        var parentVariantId = this.data.helperVariantId || this.units[0].variantId;
        properties = {
          _BundleId: group + '-' + Math.random().toString(36).slice(2, 10),
          _BundleParentVariantId: String(parentVariantId)
        };

        if (this.data.bundleTitle) {
          properties._BundleTitle = this.data.bundleTitle;
        }
      }

      var quantities = {};
      var order = [];
      this.units.forEach(function (unit) {
        if (!quantities[unit.variantId]) {
          quantities[unit.variantId] = 0;
          order.push(unit.variantId);
        }
        quantities[unit.variantId] += 1;
      });

      var items = order.map(function (variantId) {
        var item = { id: variantId, quantity: quantities[variantId] };
        if (properties) {
          item.properties = properties;
        }
        return item;
      });

      var sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );

      try {
        var response = await fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: items,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        var responseJson = await response.json();

        if (!response.ok) {
          this.errorEl.textContent = responseJson.description || this.data.strings.error;
          this.errorEl.hidden = false;
          return;
        }

        var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
        cart.sections = responseJson.sections;

        document.dispatchEvent(
          new CustomEvent('variant:add', {
            detail: {
              items: responseJson.items || [responseJson],
              cart: cart
            }
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cart
            }
          })
        );

        this.units = [];
        this.expanded = false;
      } catch (e) {
        this.errorEl.textContent = this.data.strings.error;
        this.errorEl.hidden = false;
      } finally {
        this.checkoutButton.removeAttribute('aria-busy');
        this._render();
      }
    }
  }

  window.customElements.define('bundle-builder', BundleBuilder);
})();
